/* eslint-disable no-plusplus */

import layout from 'netc-layout';

const $list = $('.product-list, .js-match-height');

if ($list.length) {
  initialise();
}

/** Initialise the module. */
function initialise(...params) {
  for (let i = 0; i < params.length; i += 1) {
    layout.equaliseHeights(params[i]);
  }
}

if ($list.length) {
  initialise();
}

$(window).load(() => {
  if ($('.promotion-content').length) {
    layout.equaliseHeights('.promotion-content .heading-text');
    layout.equaliseHeights('.promotion-content .description-text');
  }
});

$(document).ready(() => {
  const $centred = $('.js-centre-vertically');
  if ($centred.length) {
    $centred.each((index, value) => {
      const $this = $(value);
      const $children = $this.children().toArray().map(x => $(x));
      const heights = $children.map(x => x.height());
      let max = 0;
      for (let i = 0; i < heights.length; i++) {
        const height = +(heights[i]);
        if (max < height) {
          max = height;
        }
      }
      for (let i = 0; i < $children.length; i++) {
        const $child = $children[i];
        const childHeight = $child.height();
        if (max > childHeight) {
          $child.css('margin-top', (max - childHeight) / 2);
        }
      }
    });
  }
});
